// Register.js
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import logo from '../images/hosming_rojo.jpg';
import { SelectPaises } from './SelectPaises';
import { ModalRegistro } from './ModalRegistro';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";


// Importamos toast de react-toastify
import { toast } from 'react-toastify';

export const Register = ({ onSwitchToLogin }) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [countryCode, setCountryCode] = useState('591');
  const [countryAbbr, setCountryAbbr] = useState('BO');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [validationMethod, setValidationMethod] = useState('email');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [gender, setGender] = useState("M");

  const validateForm = () => {
    let isValid = true;
    const camposVacios = [];

    if (!firstName) camposVacios.push("Nombre");
    if (!lastName) camposVacios.push("Apellido");
    if (!email) camposVacios.push("Correo");
    if (!password) camposVacios.push("Contraseña");
    if (!phoneNumber) camposVacios.push("Teléfono");

    let birthdateValid = true;
    if (!birthdate) {
      camposVacios.push("Fecha de Nacimiento");
      birthdateValid = false;
    }

    const newDate = new Date();
    const currentYear = newDate.getFullYear();
    const currentMonth = newDate.getMonth()+1;
    const currentDay = newDate.getDate();
    const currentDate = new Date(`${currentYear}-${currentMonth < 10 ? '0' + currentMonth : currentMonth}-${currentDay < 10 ? '0' + currentDay : currentDay}`);

    const cumple = new Date(birthdate);
    const diferencia = currentDate - cumple;
    const oneYearToMilliseconds = 1000 * 60 * 60 * 24 * 365.25;
    const diferenciaEnAnios = diferencia / oneYearToMilliseconds;

    if (diferenciaEnAnios < 18) {
      toast.error("El usuario debe ser mayor de edad para continuar....");
      return;
    }

    if (camposVacios.length > 3) {
      toast.error("Complete los campos vacíos.");
      isValid = false;
    } else {
      // Si 3 o menos, mostramos error por cada campo
      camposVacios.forEach((campo) => {
        toast.error(`El campo '${campo}' no puede estar vacío.`);
      });
      if (camposVacios.length > 0) isValid = false;
    }

    return isValid && birthdateValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    setOpenModal(true);
  };

  const userData = {
    firstName,
    lastName,
    codePhone: countryCode,
    phone: phoneNumber,
    codeText: countryAbbr,
    fullphone: countryCode + phoneNumber,
    emailUser: email.toLowerCase(),
    password,
    password_confirmation: password,
    birth: birthdate,
    gender: gender
  };

  return (
    <>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css?family=Lato:300,400,700,900&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
        />
      </Helmet>

      <section className="ftco-section" style={{ padding: '2em 0' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-10">
              <div className="wrap d-md-flex">
                {/* Columna izquierda */}
                <div className="text-wrap p-4 p-lg-5 text-center d-flex align-items-center order-md-last">
                  <div className="text w-100">
                    <img src={logo} alt='logo' className='img-logo' />
                    <h2>Bienvenido(a)</h2>
                    <p>¿Ya tienes una cuenta?</p>
                    <button
                      type="button"
                      className="btn btn-white btn-outline-white"
                      onClick={onSwitchToLogin}
                    >
                      Inicia sesión
                    </button>
                  </div>
                </div>

                {/* Columna derecha (Formulario) */}
                <div className="login-wrap p-4 p-lg-5">
                  <div className="d-flex">
                    <div className="w-100">
                      <h3
                        className="mb-4"
                        style={{ textAlign: 'left', fontWeight: '500' }}
                      >
                        Crear una Cuenta
                      </h3>
                    </div>
                  </div>

                  <form className="signin-form" onSubmit={handleSubmit}>
                    {/* Nombre y Apellido */}
                    <div className="form-group mb-3 d-flex">
                      <div className="w-50 pr-2">
                        <label className="label">Nombre</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Nombre"
                          value={firstName}
                          min={2}
                          onChange={(e) => setFirstName(e.target.value)}
                          disabled={isSubmitting}
                        />
                      </div>
                      <div className="w-50 pl-2">
                        <label className="label">Apellido</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Apellido"
                          value={lastName}
                          min={2}
                          onChange={(e) => setLastName(e.target.value)}
                          disabled={isSubmitting}
                        />
                      </div>
                    </div>

                    {/* Correo */}
                    <div className="form-group mb-3">
                      <label className="label">Correo</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Correo"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={isSubmitting}
                      />
                    </div>

                    {/* Contraseña */}
                    <div className="form-group mb-3" style={{ position: "relative" }}>
                      <label className="label">Contraseña</label>
                      <span
                        style={{
                          color: 'red',
                          fontSize: '13px',
                          paddingLeft: '10px',
                          position: 'relative',
                          bottom: '-1px',
                        }}
                      >
                        Min. 8 caracteres y 1 número
                      </span>
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="Contraseña"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={isSubmitting}
                        style={{ paddingRight: "45px" }}
                        autoComplete="off"
                      />
                      <span
                        onClick={() => setShowPassword((prev) => !prev)}
                        style={{
                          position: "absolute",
                          top: "65%",
                          right: "15px",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#a10302",
                        }}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </span>
                    </div>


                    {/* Teléfono */}
                    <div className="form-group mb-3">
                      <label className="label">Teléfono</label>
                      <div
                        className='form-control'
                        style={{
                          width: '100%',
                          display: 'flex',
                          flexFlow: 'row nowrap',
                          justifyContent: 'start',
                          alignItems: 'center'
                        }}
                      >
                        <div className="custom-select-code">
                          <SelectPaises
                            countryCode={countryCode}
                            setCountryCode={setCountryCode}
                            countryAbbr={countryAbbr}
                            setCountryAbbr={setCountryAbbr}
                          />
                        </div>
                        <input
                          type="tel"
                          placeholder="Número de teléfono"
                          style={{
                            width: '70%',
                            background: 'transparent',
                            border: 'none',
                            height: '33px',
                            outline: 'none',
                            fontSize: '14px',
                            paddingLeft: '10px'
                          }}
                          value={phoneNumber}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (/^\d*$/.test(val)) {
                              setPhoneNumber(val);
                            }
                          }}
                          disabled={isSubmitting}
                        />
                      </div>
                    </div>

                    {/* Fecha de Nacimiento */}
                    <div className='container-date-gen'>
                      <div className="form-group mb-3">
                        <label className="label">Fecha de Nacimiento</label>
                        <input
                          type="date"
                          className="form-control"
                          placeholder="Fecha de Nacimiento"
                          value={birthdate}
                          onChange={(e) => setBirthdate(e.target.value)}
                          disabled={isSubmitting}
                        />
                      </div>

                      <div className="form-group mb-3" style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <label className="label">Genero</label>
                        <select style={{ width: '100%', borderRadius: '15px', backgroundColor: '#F2F2F2', padding: '15px', border: 'none' }} value={gender} onChange={(event) => setGender(event.target.value)}>
                          <option value={'M'}>Hombre</option>
                          <option value={'F'}>Mujer</option>
                          <option value={'O'}>Otro</option>
                        </select>
                      </div>
                    </div>

                    {/* Radio: validación en Teléfono o Email */}
                    <div className="form-group mb-3 d-flex align-items-center">
                      <label
                        className="label"
                        style={{ marginRight: '15px', fontWeight: '700' }}
                      >
                        Recibir validación en:
                      </label>
                      <div className="d-flex align-items-center">
                        <input
                          type="radio"
                          id="validacion-telefono"
                          name="validacion"
                          value="telefono"
                          onChange={() => setValidationMethod('telefono')}
                          checked={validationMethod === 'telefono'}
                          disabled={isSubmitting}
                        />
                        <label
                          htmlFor="validacion-telefono"
                          style={{ marginRight: '15px' }}
                        >
                          Teléfono
                        </label>
                        <input
                          type="radio"
                          id="validacion-email"
                          name="validacion"
                          value="email"
                          onChange={() => setValidationMethod('email')}
                          checked={validationMethod === 'email'}
                          disabled={isSubmitting}
                        />
                        <label htmlFor="validacion-email">Email</label>
                      </div>
                    </div>

                    {/* Botón de Registro */}
                    <div className="form-group">
                      <button
                        style={{ background: '#a11d1c', marginTop: '15px' }}
                        type="submit"
                        className="form-control btn btn-primary submit px-3"
                        disabled={isSubmitting}
                      >
                        Registrarse
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal de verificación */}
      <ModalRegistro
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setIsSubmitting(false);
        }}
        userData={userData}
        validationMethod={validationMethod}
        onRegisterComplete={() => {
          setOpenModal(false);
          setIsSubmitting(false);
          onSwitchToLogin();
        }}
      />
    </>
  );
};
